<section class="d-flex flex-column notification-snackbar__container">
	<template #notificationSnackbarContainerRef></template>
</section>
